<template>
  <div v-if="isMobile" class="kb-alert-container is-active">
    <div class="kb-alert">
      <div class="kb-alert-contents">
        <strong class="kb-alert-title">{{ distCrseNm }}</strong>

        <p v-if="distCrseCd === 'book'" class="kb-alert-text" v-html="bookText">
        </p>
<!--        <p v-else class="kb-alert-text">아직 신청하지 않은 과정입니다. <br>체험하기를 통해 둘러볼 수 있습니다.</p>-->
        <p v-else class="kb-alert-text">아직 신청하지 않은 과정입니다. <br>참여하시겠습니까?</p>

        <div v-if="options.length > 1" class="checkbox-group my-3">
          <div class="kb-form-check-group kb-form-check-block">
            <div v-for="(option, index) in options" class="kb-form-check" :key="index">
              <input type="radio" v-model="lrnTrgtGrpMstSn" class="kb-form-check-input" name="chk_option" :id="`chk_${index}`" :value="option.lrnTrgtGrpMstSn">
              <label :for="`chk_${index}`" class="kb-form-check-label"><span class="text">{{ option.lrnTrgtGrpNm }}</span></label>
            </div>
          </div>
        </div>
      </div>
      <div class="kb-alert-actions">
        <a v-if="distCrseCd !== 'book'" class="kb-btn-alert" @click="enrollInit"><span class="text">참여하기</span></a>
<!--        <a v-if="distCrseCd !== 'book'" class="kb-btn-alert" @click="enrollLearn"><span class="text">신청하기</span></a>-->
<!--        <button class="kb-btn-alert" @click="experienceLearn"><span class="text">체험하기</span></button>-->
<!--        <button class="kb-btn-alert" @click="closeModal"><span class="text">닫기</span></button>-->
      </div>
      <button class="kb-alert-close" @click="closeModal"><i class="icon-alert-close"></i></button>
    </div>
  </div>

  <div v-else class="layer-container is-active">
    <div class="layer" id="layer-self-learning">
      <div class="layer-contents" style="min-width: 300px;">
        <h3 class="layer-title title-lg">{{ distCrseNm }}</h3>
        <div class="layer-content mt-3">

          <p v-if="distCrseCd === 'book'" class="text text-lg" v-html="bookText"></p>
<!--          <p v-else class="text text-lg">아직 신청하지 않은 과정입니다. 체험하기를 통해 둘러볼 수 있습니다.</p>-->
          <p v-else class="text text-lg">아직 신청하지 않은 과정입니다. 참여하시겠습니까?</p>

          <div v-if="options.length > 1" class="checkbox-group mt-3">
            <div class="kb-form-check-group kb-form-check-block">
              <div v-for="(option, index) in options"  class="kb-form-check" :key="index">
                <input type="radio" v-model="lrnTrgtGrpMstSn"  class="kb-form-check-input" name="chk_option" :id="`chk_${index}`" :value="option.lrnTrgtGrpMstSn">
                <label :for="`chk_${index}`" class="kb-form-check-label"><span class="text">{{ option.lrnTrgtGrpNm }}</span></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layer-actions">
        <button v-if="distCrseCd !== 'book'" class="kb-btn-layer" @click="enrollInit"> <!-- enrollLearn -->
<!--          <strong class="text">신청하기</strong>-->
          <strong class="text">참여하기</strong>
        </button>
<!--        <button v-if="canExperience" class="kb-btn-layer" @click="experienceLearn">-->
<!--          <strong class="text">체험하기</strong>-->
<!--        </button>-->

<!--          <button v-if="distCrseCd === 'book' && !canExperience" class="kb-btn-layer" @click="closeModal">-->
<!--            <button  class="kb-btn-layer" @click="closeModal">-->
<!--              <strong class="text">닫기</strong>-->
<!--          </button>-->
      </div>
      <button class="layer-close-btn" @click="closeModal"><i class="icon-close"></i></button>
    </div>
    <!-- //[end::layer-container] -->
  </div>
</template>
<script>


import {sslEnrollSetup} from '@/assets/js/modules/ssl/setup/ssl-enroll-setup';

export default {
  name: 'SSLEnroll',
  props: {
    toggle: Boolean,
    distCrseCd: String, // distCrseCd
    socLrnPostSn:{
      type: Number,
      default: 0
    },
  },
  setup: sslEnrollSetup
}
</script>
